import React from 'react'
import Slider from 'react-slick'
import Client_1 from '../../../assets/images/home_page_3/adv-slider/01.png'

const clint = {
    slidesToShow: 4,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}

const Claint = () => {
    return (
        <>
            <div id="client-slider" className="client-slider-main-block-five">
                <Slider className="slider client-slider-center-mode" {...clint}>
                    <div className="client-slider-img">
                        <img
                            src={Client_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="client-slider-img">
                        <img
                            src={Client_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="client-slider-img">
                        <img
                            src={Client_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="client-slider-img">
                        <img
                            src={Client_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="client-slider-img">
                        <img
                            src={Client_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="client-slider-img">
                        <img
                            src={Client_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                </Slider>
            </div>

        </>
    )
}

export default Claint
